<img class="img-events" src="assets/events.svg">
<div class="container">
    <!--Checking the presence of the events-->
    <div *ngIf="events" class="row">
        <div class="col-12">
            <div class="heading">
                <h1>Events</h1>
                <h5>All events created by users</h5>
                <div *ngIf="themes$ | async as themes" class="d-flex mt-4">
                    <!--Filtering events by the field (id)-->
                    <input (keyup)="filter('id', $event.target.value)" class="form-control mr-3 w-50"
                           placeholder="Search by id"
                           type="text">
                    <select (change)="filter('theme', $event.target.value)" class="form-control w-50">
                        <option value="" selected>Filter by theme</option>
                        <option *ngFor="let theme of themes" [value]="theme.id">{{theme.name}}</option>
                    </select>
                </div>
            </div>
            <!--List of events-->
            <div *ngFor="let event of filteredEvents" class="event-item px-3">
                <!--Rounded image of an event-->
                <a [routerLink]="'/events/'+event.id" class="d-flex">
                    <div [style.background-image]="'url('+getImage(event.image)+')'" class="image"></div>
                    <div class="mx-3 d-flex">
                        <div class="event-id mr-2">{{event.id.substr(event.id.length - 5)}}</div>
                        <div class="small">hosted by {{event.participants[0].name}}</div>
                    </div>
                </a>
                <!--Formatting the date of an event-->
                <div class="d-flex">
                    <div>{{event.date | date: 'dd.MM.yyyy'}}, {{event.time}}</div>
                    <div class="toggle-switch ml-5">
                        <ng-switchery (click)="toggleEvent(event.id, event.active)" [(ngModel)]="event.active"
                                      color="switchery-success"></ng-switchery>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
